// @ts-nocheck
import { useEffect, useState, useRef, useCallback } from 'react'

import * as React from 'react'
import CheckmarkSectionContainer from 'components/atoms/CheckmarkSection'
import BulletPoinntSectionContainer from 'components/atoms/BulletPointSection'
const CourseMaterials = dynamic(
  () => import('components/molecules/CourseMaterials'),
  { ssr: false, loading: () => <Loader count={8} /> }
)
// import CourseMaterials from 'components/molecules/CourseMaterials'
// import AboutAuthor from 'components/molecules/AboutAuthor'
const AboutAuthor = dynamic(() => import('components/molecules/AboutAuthor'), {
  ssr: false,
  loading: () => <Loader count={6} />,
})
import StickyCoursePageBlock from '@components/molecules/StickyCoursePageBlock'
// const StickyCoursePageBlock = dynamic(
//   () => import('@components/molecules/StickyCoursePageBlock'),
//   { ssr: false }
// )
import { CourseLanguageIcon } from '@public/static/icons/course-language'
import GiftIcon from 'public/static/icons/gift-icon'
import WishlistIcon from 'public/static/icons/headerIcons/wishlist-icon'
import IconText from 'components/atoms/IconText'
import CartIcon from '@public/static/icons/headerIcons/cart-icon'
import ShareIcon from '@public/static/icons/share-icon'
import useWindowDimensions from '@hooks/useWindowDimensions'
import { fontFamilies } from '@configs/styles/config'
import VideoPlayIcon from '@public/static/icons/video-play-icon'
import { ShortCourse } from 'types/course'
import Link from 'next/link'
const ReportProblem = dynamic(
  () => import('@components/organisms/ReportProblem'),
  { ssr: false }
)
import { useCartAndWishList } from '@contexts/CartAndWishList'

import {
  Body,
  FixedPart,
  CourseTitle,
  AuthorName,
  NumbersContainer,
  ReportBlock,
  FloatingPart,
  TopContainer,
  DescriptionHeader,
  ShowMore,
  ShowMoreLine,
  TopBg,
  VideoPlayerWrapper,
  PlayIconContainer,
  PlayIconWrapper,
  OtherCourses,
  OtherCoursesHeading,
  SectionsRouteContainer,
  RouteButton,
  Separator,
} from './styled.components'
// import VideoPlayerModal from '@components/organisms/VideoPlayerModal'
const VideoPlayerModal = dynamic(
  () => import('@components/organisms/VideoPlayerModal'),
  { ssr: false }
)
import { StudentQtyIconNew } from '@public/static/icons/students-qty-icon'
import { TimeAmountIconNew } from '@public/static/icons/time-amount-icon'

const CartModal = dynamic(() => import('../CartModal'), { ssr: false })
import { useAuth } from '@contexts/Auth'
import { useRouter } from 'next/router'
import { getLocalizedCategoryName } from '@utils/getLocalizedCategoryName'
// import GiftCourseModal from '@components/molecules/GiftCourseModal'
// import CourseReviews from '@components/molecules/CourseReviews'
const CourseReviews = dynamic(
  () => import('@components/molecules/CourseReviews'),
  { ssr: false, loading: () => <Loader count={5} /> }
)
const GiftCourseModal = dynamic(
  () => import('@components/molecules/GiftCourseModal')
)
import { GiftDetails } from '@type/gift'

import Rating from '@components/atoms/Rating'
import { colors } from '@configs/styles/config'
import { Button as Nbutton, useDisclosure } from '@nextui-org/react-latest'
import { getCoursePricingPolicies } from '@services/api/course'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import Version from '@type/course/version'
const OtherCoursesByAuthor = dynamic(() => import('../OtherCoursesByAuthor'), {
  ssr: false,
  loading: () => <Loader count={6} />,
})
const languages = dynamic(() => import('@constants/languages'), {
  ssr: false,
})
import dynamic from 'next/dynamic'
import Author from '@type/_user/author'
import PlayIcon from '@public/static/icons/videoPlayerIcons/playIcon'
// import ShareCourseModal from './components/ShareModal'
const ShareCourseModal = dynamic(() => import('./components/ShareModal'), {
  ssr: false,
})
// import FixedBuyNow from './components/FixedBuyNow'
const FixedBuyNow = dynamic(() => import('./components/FixedBuyNow'))
import Loader from './components/Loader'
import CloseIcon from '@public/static/icons/toast/CloseIcon'
import { calculateCourseTime } from '@utils/calculateCourseTime'
import Image from 'next/image'
import { logEvent } from 'firebase/analytics'
import { analytics } from '@configs/firebase'
// import ShareModal from './components/ShareModal'

const VideoPlayer = dynamic(() => import('@components/organisms/VideoPlayer'), {
  ssr: false,
})

type CoursePageBlockProps = {
  course: Version | null
  isPreview?: boolean
  exitPreview?: () => void
  course_id?: string
  exitPreviewBtnRef?: any
}

const CoursePageBlock: React.FC<CoursePageBlockProps> = (props) => {
  const router = useRouter()
  const { user, isAuthLoading: isAPILoading } = useAuth()
  const { width } = useWindowDimensions()
  const { t } = useTranslation([
    'common',
    'review',
    'stickyCoursePageBlock',
    'courseReviews',
  ])

  const topContainerRef = useRef<HTMLDivElement>(null)

  const {
    isPreview = false,
    course,
    exitPreview,
    course_id,
    exitPreviewBtnRef,
  } = props
  const [totalCourseTime, setTotalCourseTime] = useState<number>(0)
  const [totalCourseLectures, setTotalCourseLectures] = useState<number>(0)
  const [openDesc, setOpenDesc] = useState<boolean>(false)
  const [showCheckoutModal, setShowCheckoutModal] = useState(false)
  const [shortVersion, setShortVersion] = useState<ShortCourse>({
    _id: course_id,
    title: course?.title,
    status: course?.status,
    author: course?.author,
    ratingQty: course?.ratingQty,
    rating: course?.rating,
    shortCourseDescription: course?.shortCourseDescription,
    price: course?.price,
    salePrice: course?.salePrice,
    whatYouWillLearn: course?.whatYouWillLearn,
    presentationalImage: course?.presentationalImage,
    keywords: course?.keywords,
    totalTime: course?.totalTime,
    totalLectures: course?.totalLectures,
  })

  const [topBlockHeight, setTopBlockHeight] = useState(0)

  const [isTitleInViewPort, setIsTitleInViewPort] = useState<boolean>(false)

  const [showPresentationalVideo, setShowPresentationalVideo] =
    useState<boolean>(false)
  const observer = useRef()
  const [isInPreview, setIsInPreview] = useState<boolean>(false)
  const [playVideo, setPlayVideo] = useState(false)
  const [isDescOverflowing, setIsDescOverflowing] = useState(false)
  const descRef = useRef<HTMLDivElement>()
  const [authorDetails, setAuthorDetails] = useState<Author | undefined>(
    undefined
  )
  const [avgRating, setAvgRating] = useState(0)
  const [videoControlsState, setVideoControlsState] = useState(false)
  const {
    isOpen: isGiftOpen,
    onOpen: onGiftOpen,
    onOpenChange: onGiftOpenChange,
    onClose: onGiftClose,
  } = useDisclosure()
  const {
    isOpen: isReportOpen,
    onOpen: onReportOpen,
    onOpenChange: onReportOpenChange,
    onClose: onReportClose,
  } = useDisclosure()
  const { isOpen, onOpen, onOpenChange } = useDisclosure()
  const {
    addToCart,
    setCartItemType,
    addToWishlist,
    wishlistItems,
    setGiftDetails,
    setInstantCheckoutItem,
    cartItems,
  } = useCartAndWishList()
  const videoTempRef = useRef<React.MutableRefObject<ReactPlayer>>()
  const fullScreenHandlerRef = useRef<() => void>()

  useEffect(() => {
    if (isInPreview && playVideo) {
      setPlayVideo(false)
    }
  }, [isInPreview, playVideo])

  useEffect(() => {
    let totalTime = 0
    let totalLectures = 0
    course?.course_materials.sections.forEach((section) => {
      section.lectures.forEach((lecture) => {
        totalTime = totalTime + lecture?.content?.duration
      })
      totalLectures = totalLectures + section.lectures.length
    })

    setTotalCourseTime(totalTime)
    setTotalCourseLectures(totalLectures)
    if (isPreview) {
      getCoursePricingPolicies(course_id, course?.version).then((res) => {
        if (res.length > 0) {
          const timestamp = dayjs().format()
          const activePolicy = res.filter(
            (p) =>
              p.isActive &&
              p.type === 'override' &&
              p.startDate <= timestamp &&
              p.expiryDate >= timestamp
          )?.[0]
          if (activePolicy) {
            if (activePolicy.showOriginalPrice) {
              setShortVersion((state) => ({
                ...state,
                price: activePolicy.initialValue || state.price,
                salePrice: activePolicy.value,
              }))
            } else {
              setShortVersion((state) => ({
                ...state,
                price: activePolicy.value,
              }))
            }
          }
        }
      })
    }
  }, [course, course_id, isPreview])

  useEffect(() => {
    document.getElementsByTagName('html')[0].style.scrollBehavior = 'smooth'
  }, [])

  const giftCourseHandler = (e: GiftDetails) => {
    setGiftDetails(e)
    onGiftClose()
    setCartItemType('Course')
    setInstantCheckoutItem(shortVersion)
    router.push('/checkout')
  }

  const buyNowHandler = () => {
    if (!cartItems?.find((item) => item?._id === shortVersion?._id)) {
      addToCart(shortVersion, 'Course', false)
    }
    if (analytics) {
      logEvent(analytics, 'buy_now', {
        currency: 'USD',
        value: (shortVersion?.salePrice ?? shortVersion?.price ?? 0) / 100,
        items: [
          {
            item_id: shortVersion?._id,
            item_name: shortVersion?.title,
            price: (shortVersion?.salePrice ?? shortVersion?.price ?? 0) / 100,
          },
        ],
      })
    }
    setCartItemType('Course')
    setInstantCheckoutItem(shortVersion)
    router.push(`/checkout?courseId=${shortVersion._id}`)
  }

  const titleVisibilityHandler = (enteries) => {
    if (enteries[0].isIntersecting) {
      setIsTitleInViewPort(true)
    } else {
      setIsTitleInViewPort(false)
    }
  }

  const containerRef = useCallback(
    (node: HTMLDivElement) => {
      if (width > 1050) return
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 1,
      }
      if (observer.current) observer.current?.disconnect()
      observer.current = new IntersectionObserver(
        titleVisibilityHandler,
        options
      )

      if (node) observer.current.observe(node)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [width]
  )

  useEffect(() => {
    function handleResize() {
      if (topContainerRef.current) {
        setTopBlockHeight(topContainerRef.current?.clientHeight)
      } else {
        setTopBlockHeight(0)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return (): void => window.removeEventListener('resize', handleResize)
  }, [course])

  const previewCallback = (state: boolean) => {
    setIsInPreview(state)
  }

  useEffect(() => {
    const el = descRef.current
    if (!el) return

    // Save current clamp state to avoid DOM thrashing
    const wasClamped = el.classList.contains('line-clamp-5')

    if (wasClamped) el.classList.remove('line-clamp-5')

    // Use requestIdleCallback or requestAnimationFrame to wait for layout paint
    const measure = () => {
      const fullHeight = el.scrollHeight
      if (wasClamped) el.classList.add('line-clamp-5')
      const clampedHeight = el.clientHeight

      // Only update state if value changes (avoid re-renders)
      setIsDescOverflowing(fullHeight > clampedHeight + 2)
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(measure, { timeout: 100 })
    } else {
      requestAnimationFrame(measure)
    }
  }, [course.description])

  const handlePlayVideo = () => {
    if (videoTempRef.current) {
      videoTempRef.current?.getInternalPlayer()?.play()
      setPlayVideo(true)
    }
  }

  const controlsState = (state: boolean) => {
    setVideoControlsState(state)
  }

  const isInWishlist =
    wishlistItems?.filter((item) => item?._id == course?._id)?.length > 0

  return (
    course && (
      <div style={{ width: '100%' }}>
        {!isPreview && (
          <TopBg
            topBlockHeight={topBlockHeight}
            top={topContainerRef.current?.getBoundingClientRect()?.top || 0}
          />
        )}
        <Body
          style={{ fontFamily: fontFamilies.regular }}
          className="!max-w-full sm:px-2 md:px-0"
        >
          <FixedBuyNow
            course={course}
            avgRating={avgRating}
            buyNowHandler={buyNowHandler}
            isTitleInViewPort={isTitleInViewPort}
          />
          <FixedPart>
            <TopContainer ref={topContainerRef}>
              {!isPreview && (
                <SectionsRouteContainer hiddenOnMobile={true}>
                  <RouteButton
                    onClick={() => {
                      router.push(
                        {
                          pathname: '/',
                          query: {
                            category: JSON.stringify([course?.category?._id]),
                            subCategory: JSON.stringify([]),
                          },
                        },
                        undefined,
                        { shallow: false }
                      )
                    }}
                  >
                    {getLocalizedCategoryName(
                      course?.category?.name,
                      router.locale
                    )}
                  </RouteButton>
                  <Separator>/</Separator>
                  <RouteButton
                    onClick={() => {
                      router.push(
                        {
                          pathname: '/',
                          query: {
                            category: JSON.stringify([course?.category?._id]),
                            subCategory: JSON.stringify([
                              course?.subCategory?._id,
                            ]),
                          },
                        },
                        undefined,
                        { shallow: false }
                      )
                    }}
                    className="!font-semiBold"
                  >
                    {getLocalizedCategoryName(
                      course?.subCategory?.name,
                      router.locale
                    )}
                  </RouteButton>
                </SectionsRouteContainer>
              )}
              <VideoPlayerWrapper className="laptop:hidden flex">
                {course.presentationalVideo?.public?.url && !playVideo && (
                  <PlayIconContainer>
                    <button
                      onClick={handlePlayVideo}
                      className="bg-transparent"
                      aria-label="Play"
                    >
                      <PlayIconWrapper>
                        <VideoPlayIcon width="100%" />
                      </PlayIconWrapper>
                    </button>
                  </PlayIconContainer>
                )}

                {course?.presentationalImage && (
                  <span
                    className={playVideo ? 'hidden' : 'inline w-full h-full'}
                  >
                    <Image
                      src={course?.presentationalImage}
                      width={375}
                      height={175}
                      alt={course?.title || 'Course'}
                      className="bg-uguDarkBrightPurple/80 w-full h-full object-cover aspect-video rounded-xl"
                    />
                  </span>
                )}
                {course.presentationalVideo?.public?.url &&
                  (width || 0) < 1050 && (
                    <span
                      className={`w-full h-full relative ${
                        playVideo ? 'inline' : 'hidden'
                      }`}
                    >
                      <VideoPlayer
                        videoURL={course.presentationalVideo?.public?.url}
                        videoName={''}
                        isMultipleVideos={false}
                        nextLectureTitle={undefined}
                        previousLectureTitle={undefined}
                        isWideScreen={false}
                        isModal={true}
                        showReplayButton={false}
                        showWideScreen={false}
                        playing={playVideo}
                        videoTempRef={videoTempRef}
                        height={'56vw'}
                        controlsState={controlsState}
                        fullScreenHandlerRef={fullScreenHandlerRef as undefined}
                      >
                        {videoControlsState && (
                          <button
                            className="absolute z-10 top-3 right-3 bg-transparent"
                            onClick={() => {
                              if (videoTempRef.current) {
                                setPlayVideo(false)
                                videoTempRef.current.getInternalPlayer().pause()
                                fullScreenHandlerRef.current?.()
                              }
                            }}
                          >
                            <CloseIcon />
                          </button>
                        )}
                      </VideoPlayer>
                    </span>
                  )}
              </VideoPlayerWrapper>
              <CourseTitle
                className="sm:text-inherit text-xl"
                ref={containerRef}
              >
                {course?.title}
              </CourseTitle>
              <h2 className="break-words font-light mt-[0.5rem] text-lg tracking-normal">
                {course?.shortCourseDescription || ''}
              </h2>
              <NumbersContainer>
                <Link href={'#reviews'} style={{ textDecoration: 'none' }}>
                  <div style={{ marginBottom: '20px', marginRight: '1rem' }}>
                    <Rating
                      value={isPreview ? 4.8 : avgRating}
                      text={`${course.ratingQty || 5}`}
                      showText={true}
                      textStyle={{
                        paddingTop: '1px',
                        textDecoration: 'underline',
                        fontSize: '0.9rem',
                      }}
                      showNumber={true}
                      iconMargin={
                        width && width < 420 ? '0.125rem ' : '0.25rem'
                      }
                      iconWidth={'1.15rem'}
                    />
                  </div>
                </Link>
                <IconText
                  icon={<StudentQtyIconNew />}
                  text={
                    course.studentsQty
                      ? `${Math.round(course.studentsQty)} ${t('studentsLabel', { ns: 'stickyCoursePageBlock' })}`
                      : t('noStudentsYet', { ns: 'stickyCoursePageBlock' })
                  }
                  marginRight="1rem"
                  color="#000"
                  opacity="1"
                  marginBottom="20px"
                />
                <IconText
                  icon={<TimeAmountIconNew />}
                  text={
                    t('lastUpdate', { ns: 'stickyCoursePageBlock' }) +
                      ': ' +
                      course?.updatedAt?.substr(0, 10) || ''
                  }
                  marginRight="1rem"
                  color="#000"
                  opacity="1"
                  marginBottom="20px"
                />
                <IconText
                  icon={<CourseLanguageIcon />}
                  text={
                    languages[course?.languages[0]]?.name ||
                    t('english', { ns: 'courseReviews' })
                  }
                  marginRight={'1rem'}
                  opacity="1"
                  marginBottom="20px"
                />
              </NumbersContainer>
              <AuthorName>
                <span className="font-light">
                  {t('author', { ns: 'stickyCoursePageBlock' })}:{' '}
                </span>
                <b>
                  {course.author &&
                    course.author.first_name + ' ' + course.author.last_name}
                </b>
              </AuthorName>
              <div className="gap-4 md:gap-5 flex flex-wrap mt-3">
                <Nbutton
                  className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple"
                  variant="light"
                  style={{ border: '1px solid ' + colors.uguPurple }}
                  onClick={() => (isPreview ? {} : onGiftOpen(true))}
                  isDisabled={isPreview}
                >
                  <GiftIcon height="1.1rem" />{' '}
                  {t('giftCourse', { ns: 'stickyCoursePageBlock' })}
                </Nbutton>
                {isAPILoading ? (
                  <></>
                ) : (
                  user?.purchased_courses?.includes(course_id) ||
                  user?.my_courses?.includes(course_id) || (
                    <Nbutton
                      className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple"
                      variant="light"
                      style={{
                        border: isInWishlist
                          ? ''
                          : '1px solid ' + colors.uguPurple,
                        backgroundColor: isInWishlist
                          ? '#C7424F1A'
                          : 'rgb(0,0,0,0)',
                      }}
                      onClick={() => addToWishlist(shortVersion)}
                    >
                      <WishlistIcon height="1.1rem" />{' '}
                      {wishlistItems.filter((item) => item._id == course._id)
                        .length > 0
                        ? t('inWishlist', { ns: 'stickyCoursePageBlock' })
                        : t('addToWishlist', {
                            ns: 'stickyCoursePageBlock',
                          })}
                    </Nbutton>
                  )
                )}
                {user?.my_courses?.includes(course_id) ? (
                  <Nbutton
                    className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple laptop:hidden"
                    variant="light"
                    style={{
                      border: '1px solid ' + colors.uguPurple,
                    }}
                    onClick={() => router.push('/create-course/' + course?._id)}
                  >
                    {t('buttons.manage', { ns: 'stickyCoursePageBlock' })}
                  </Nbutton>
                ) : (
                  user?.purchased_courses?.includes(course_id) || (
                    <Nbutton
                      className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple laptop:hidden"
                      variant="light"
                      style={{
                        border: '1px solid ' + colors.uguPurple,
                      }}
                      onClick={() => {
                        addToCart(shortVersion)
                        setShowCheckoutModal(true)
                      }}
                    >
                      <CartIcon height="1.1rem" />
                      {t('buttons.addToCart', {
                        ns: 'stickyCoursePageBlock',
                      })}
                    </Nbutton>
                  )
                )}
                {user?.purchased_courses?.includes(course_id) && (
                  <Nbutton
                    className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple laptop:hidden"
                    variant="light"
                    style={{
                      border: '1px solid ' + colors.uguPurple,
                    }}
                    onClick={() => router.push(`/study-course/${course_id}/`)}
                  >
                    <PlayIcon height="1.03rem" />
                    {t('continueLearning', { ns: 'stickyCoursePageBlock' })}
                  </Nbutton>
                )}

                <Nbutton
                  className="px-[17.5px] h-[46px] font-regular tracking-normal text-uguPurple laptop:hidden"
                  variant="light"
                  style={{
                    border: '1px solid ' + colors.uguPurple,
                  }}
                  onClick={onOpen}
                >
                  <ShareIcon height="1.1rem" />
                  {t('Share', { ns: 'stickyCoursePageBlock' })}
                </Nbutton>
              </div>
            </TopContainer>
            <CheckmarkSectionContainer
              title={t('whatYouLearn', { ns: 'stickyCoursePageBlock' })}
              list={course?.whatYouWillLearn}
              marginTop="6px"
            />
            <BulletPoinntSectionContainer
              title={t('requirements', { ns: 'stickyCoursePageBlock' })}
              list={course?.requirements}
              marginTop="20px"
            />
            <DescriptionHeader>
              {t('description', { ns: 'courses' })}
            </DescriptionHeader>
            <div className="relative">
              {/* <div className="-mx-[0.5rem]">
                <TinyEditor
                  readOnly={true}
                  onInit={onInit}
                  value={course?.description}
                />
              </div> */}
              <div className={`${openDesc ? '' : 'line-clamp-5'}`}>
                <div
                  ref={descRef}
                  className={`prose prose-sm mt-2 prose-li:marker:text-uguPurple prose-slate`}
                  dangerouslySetInnerHTML={{ __html: course?.description }}
                />
              </div>
              {isDescOverflowing && !openDesc && (
                <div className="w-full absolute bottom-0 left-0 h-20 bg-gradient-to-t via-transparent from-white to-transparent" />
              )}
            </div>
            {isDescOverflowing && (
              <ShowMore
                className="!mt-2"
                style={{ display: true ? 'flex' : 'hidden' }}
              >
                <ShowMoreLine />
                <Nbutton
                  className="rounded-full font-regular bg-transparent md:scale-100 scale-85 px-5"
                  style={{ border: '1px solid ' + colors.uguPurple }}
                  onClick={() => {
                    setOpenDesc(!openDesc)
                  }}
                >
                  {t('show', { ns: 'courses' })}{' '}
                  {openDesc
                    ? t('less', { ns: 'courses' })
                    : t('more', { ns: 'courses' })}
                </Nbutton>
                <ShowMoreLine />
              </ShowMore>
            )}
            <CourseMaterials
              course={course}
              sections={course?.course_materials?.sections}
              totalTime={totalCourseTime}
              totalLectures={totalCourseLectures}
              course_id={course_id}
              previewCallback={previewCallback}
            />
            <AboutAuthor
              course={course}
              value={course?.aboutAuthor ? course?.aboutAuthor : ''}
              setAuthorDetails={setAuthorDetails}
            />
            {!isPreview && (
              <>
                <div id="reviews">
                  <CourseReviews
                    courseId={course_id}
                    ratingBreakDown={course?.ratingBrakeDown}
                    rating={course.rating}
                    authorDetails={authorDetails}
                    setAvgRating={setAvgRating}
                    avgRating={avgRating}
                  />
                </div>
                <OtherCourses>
                  <OtherCoursesHeading>
                    {t('otherAuthorCourses', { ns: 'stickyCoursePageBlock' })}
                  </OtherCoursesHeading>
                  <OtherCoursesByAuthor
                    courseId={course?._id || ''}
                    authorId={course.author?._id || ''}
                  />
                </OtherCourses>
                <ReportBlock>
                  <Nbutton
                    variant="flat"
                    onClick={onReportOpen}
                    className="font-bold md:px-20 px-12 rounded-full h-12 text-uguPurple"
                  >
                    {t('reportProblem', { ns: 'courses' })}
                  </Nbutton>

                  <ReportProblem
                    onClose={onReportClose}
                    itemType="Course"
                    isOpen={isReportOpen}
                    onOpenChange={onReportOpenChange}
                    itemId={course._id}
                  />
                </ReportBlock>
              </>
            )}
          </FixedPart>
          <FloatingPart>
            <StickyCoursePageBlock
              course={course}
              shortVersion={shortVersion}
              buyNow={buyNowHandler}
              isPreview={isPreview}
              exitPreview={exitPreview}
              totalTime={totalCourseTime}
              totalLectures={totalCourseLectures}
              setShowPresentationalVideo={setShowPresentationalVideo}
              setShowCheckoutModal={setShowCheckoutModal}
              openShareModal={onOpen}
              exitPreviewBtnRef={exitPreviewBtnRef}
              isInPreview={isInPreview}
            />
          </FloatingPart>

          {showPresentationalVideo && (
            <VideoPlayerModal
              autoplay={true}
              videoLink={course.presentationalVideo?.public?.url}
              onClose={() => setShowPresentationalVideo(false)}
              videoName="Presentational Video"
            />
          )}
        </Body>

        {showCheckoutModal ? (
          <CartModal
            isOpen={showCheckoutModal}
            onClose={() => setShowCheckoutModal(false)}
            shouldBlockScroll={false}
          />
        ) : (
          <></>
        )}

        {isOpen ? (
          <ShareCourseModal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            course={course}
            rating={avgRating}
            students={new Intl.NumberFormat('en-US', {
              notation: 'compact',
              compactDisplay: 'short',
            }).format((course?.studentsQty || 0) as number)}
            duration={calculateCourseTime(course?.totalTime || 0)}
          />
        ) : (
          <></>
        )}

        <GiftCourseModal
          isPreview={isPreview}
          onSubmit={giftCourseHandler}
          status={shortVersion.status}
          isOpen={isGiftOpen}
          onOpenChange={onGiftOpenChange}
        />
      </div>
    )
  )
}
export default CoursePageBlock
